/* eslint-disable react/prop-types */
import React from 'react';
import { t } from 'es6/services/localization';

function Annotations({ annotations, onEscape }) {
  return (
    <div className="annotation-area">
      <div className="content">
        <p className="note">{t('note')}</p>
        <p className="text">{annotations}</p>
      </div>
      <button className="btn btn-bar btn-default return-to-main" onClick={onEscape}>Esc</button>
    </div>
  );
}

export default Annotations;
